// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UyzG","colMin":"styles_colMin__2YRSv"};